import React from 'react';
import PropTypes from 'prop-types';
import { AuthProvider, useAuth } from 'react-oidc-context';
import Loading from '../components/loading';
import { useHistory } from 'react-router-dom';

const FetchContext = React.createContext();

export const useFetch = () => React.useContext(FetchContext);

const AuthenticationInner = ({ children }) => {
    const auth = useAuth();

    if (auth.isLoading || auth.error) {
        return <Loading active />;
    }

    if (auth.isAuthenticated) {
        // Create a fetch alias that injects the token
        const fetch = (url, opts) => {
            opts = opts || {};
            const headers = (opts.headers = opts.headers || {});
            headers.Authorization = `${auth.user.token_type} ${auth.user.access_token}`;
            return window.fetch(url, opts);
        };

        // Inject a fetch command in a context
        return <FetchContext.Provider value={fetch}>{children}</FetchContext.Provider>;
    }
    return <SigninRedirect />;
};

const SigninRedirect = () => {
    const auth = useAuth();
    React.useEffect(() => {
        auth.signinRedirect({
            url_state: String(window.location.pathname)
        });
    }, [auth]);
    return null;
};

export const Authentication = ({ children, config }) => {
    const history = useHistory();

    const onSigninCallback = user => {
        const dest = user.url_state || '/ticket/';
        history.push(dest);
    };

    return (
        <AuthProvider
            automaticSilentRenew
            authority={config.OIDCUrl}
            redirect_uri={`${window.location.origin}/ticket/`}
            onSigninCallback={onSigninCallback}
            client_id={config.clientId}
        >
            <AuthenticationInner>{children}</AuthenticationInner>
        </AuthProvider>
    );
};

Authentication.propTypes = {
    children: PropTypes.node.isRequired,
    config: PropTypes.shape({
        OIDCUrl: PropTypes.string,
        clientId: PropTypes.string
    }).isRequired
};
